module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingReceiverPage"
    }
  }, [_c('div', {
    staticClass: "help"
  }, [_c('span', {
    staticClass: "help-icon",
    on: {
      "click": function($event) {
        _vm.helpCliked()
      }
    }
  }, [(!_vm.help_cliked) ? _c('i', {
    staticClass: "icon-question-sign"
  }) : _vm._e(), _vm._v(" "), (_vm.help_cliked) ? _c('i', {
    staticClass: "icon-circledelete"
  }) : _vm._e()]), _vm._v(" "), (_vm.help_cliked) ? _c('div', {
    staticClass: "help_information"
  }, [_c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("振替依頼をされた場合")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.$router.push('/table')
      }
    }
  }, [_vm._v("\n    座席予約表トップへ\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "helpOl"
  }, [_c('li', [_vm._v("「〇〇様からの授業振替依頼が届きました」または「〇〇先生からの授業振替依頼が届きました」という件名のメールが届く")]), _vm._v(" "), _c('li', [_vm._v("メール内のURLをクリック")]), _vm._v(" "), _c('li', [_vm._v("画面の指示に従い、入力を進める")]), _vm._v(" "), _c('ol', [_c('li', {
    staticStyle: {
      "font-weight": "bold",
      "margin-top": "5px"
    }
  }, [_vm._v("【承認する場合】")]), _vm._v(" "), _c('ol', {
    staticClass: "helpO2 ol-second-level"
  }, [_c('li', [_vm._v("①振替候補日時からご都合の良い日時を選択")]), _vm._v(" "), _c('li', [_vm._v("　（講師のみ振替後の授業の情報を指定）")]), _vm._v(" "), _c('li', [_vm._v("②振替後の授業を予約する座席を選択")]), _vm._v(" "), _c('li', [_vm._v("③入力項目を確認し、「振替を確定する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("　または、「戻って修正する」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("④完了画面を確認し、「座席表トップへ」をクリック")])]), _c('br'), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-weight": "bold",
      "margin-top": "5px"
    }
  }, [_vm._v("【不承認する場合】")]), _vm._v(" "), _c('ol', {
    staticClass: "helpO2 ol-second-level"
  }, [_c('li', [_vm._v("①「振替を不承認する」にチェックを入れる")]), _vm._v(" "), _c('li', [_vm._v("　（講師のみ振替後の授業の情報を指定）")]), _vm._v(" "), _c('li', [_vm._v("②他の振替候補日時を入力")]), _vm._v(" "), _c('li', [_vm._v("③入力項目を確認し、「振替依頼を不承認する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("　または、「戻って修正する」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("④完了画面を確認し、「座席表」をクリック")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messagetext"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("承認/不承認をしたあとは・・・")]), _vm._v("\n  \t\t\t\t承認・不承認の結果がメールで依頼者に届きます。"), _c('br'), _vm._v("\n  \t\t\t\t承認した場合は、そのまま振替後の日時に教室にお越しください。"), _c('br'), _vm._v("\n  \t\t\t\t不承認した場合は、依頼者から別の振替候補日時が提案されますので、再度承認/不承認を行ってください。\n  \t\t")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-80d6c638", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80d6c638"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReschedulingPage/ReschedulingReceiverPage.vue
// module id = 737
// module chunks = 0